import {Component, Input, OnInit} from '@angular/core';
import {Field, FieldCrop} from 'shared';

@Component({
  selector: 'app-field-editor-map-popup',
  templateUrl: './field-editor-map-popup.component.html',
  styleUrls: ['./field-editor-map-popup.component.scss']
})
export class FieldEditorMapPopupComponent implements OnInit {

  @Input()
  field: Field;

  @Input()
  crop: FieldCrop;

  tabs = [
    {text: 'Inforamtion'},
    {text: 'Editer'},
    {text: 'Proximité'},
  ];
  selectedIndex = 0;

  constructor() {
  }

  ngOnInit(): void {
  }

  selectTab(e: any) {

  }

}
